import React from "react";
import { cn } from "../../lib/utils";

function Label({ className, ref, ...props }) {
  return (
    <label
      ref={ref}
      className={cn(
        // .form-label
        "mb-1 block text-sm font-medium text-primary-900",
        className
      )}
      {...props}
    />
  );
}

export { Label };
